import { X, TreeDeciduous } from 'lucide-react';

import type { UserRow } from '../userViewModel';

import UserAvatar from './UserAvatar';
import UserStatusPills from './UserStatusPills';

interface UserDetailHeaderProps {
  user: UserRow;
  onClose: () => void;
}

/** Top section of the detail pane: avatar, name, email, status badges,
 *  and a close button. */
export default function UserDetailHeader({ user, onClose }: UserDetailHeaderProps) {
  return (
    <div className="p-[18px] pb-3.5 flex gap-3.5">
      <UserAvatar name={user.name} size={48} />
      <div className="flex-1 min-w-0">
        <div
          id={`user-detail-title-${user.id}`}
          className="text-base font-bold text-bark-900 dark:text-[#e8ece9]"
        >
          {user.name}
        </div>
        <div className="text-xs text-stone-600 dark:text-stone-400 mt-0.5">
          {user.email || 'No email on file'}
        </div>
        <div className="mt-2 flex gap-1.5 flex-wrap">
          <UserStatusPills user={user} />
          {user.isStaff && (
            <span className="inline-flex items-center gap-1 h-5 px-1.5 rounded-full text-[10.5px] font-semibold bg-[#EAF3DE] text-[#173404] border border-moss-200">
              <TreeDeciduous size={10} />
              Staff profile
            </span>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close detail pane"
        className="w-7 h-7 rounded-md text-stone-500 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28] inline-flex items-center justify-center"
      >
        <X size={16} />
      </button>
    </div>
  );
}
